export default __webpack_public_path__ + "static/media/img_roadmap-m.0c1bd79c.png";